import Vue from 'vue'
import Vuex from 'vuex'
import {auth} from "@/store/auth.module";
import router from '../router/index'
import storage from './storage'
import {loader} from "@/store/loader.module";

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [
        storage({
            storedKeys: ['token', 'permissions', 'userName','menuList'],
            destroyOn: ['destroySession']
        }),

    ],

    state: {
        // barColor: "#233",
        barImage: require('../assets/back.jpg'),
        drawer: false,
        mini: true,
        menuList:[],
        token: '',
        userName: '',
        permissions: [],
    },


    getters: {
        isLoggedIn(state) {
            return !!state.token
        },


    },

    mutations: {
        SET_BAR_IMAGE(state, payload) {
            state.barImage = payload
        },
        SET_DRAWER(state, payload) {
            state.drawer = payload;
        },
        SET_MINI(state, payload) {
            state.mini = payload;
        },

        createSession(state, session) {
            state.token = session.headers['authorization']
            state.permissions = session.data.permissions
            state.userName = session.data.username
            state.menuList = session.data.menuDTOList

        },

        destroySession(state) {
            state.token = ''
            state.permissions = []
            state.userName = ''
        }
    },

    actions: {
        sessionExpired({dispatch, commit}) {
            dispatch('notifications/info', 'Session has been expired')
            commit('destroySession')
            router.push('/login')
        },

        forbidden({dispatch}, response) {
            dispatch('notifications/error', response.body.message)
            router.back()
        },


    },

    modules: {
        auth,loader

    }

})
